import { trackError } from '@billy/track-error'
import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../../enums/queryKeys'
import { fetchBanksList } from '../query-api'

export const useFetchBanks = () => {
  const { organization } = useUserOrganization()
  const organizationId = organization?.id
  const countryId = organization?.countryId

  const { data, isLoading, isIdle } = useQuery(
    [QueryKeys.BanksList, organizationId, countryId],
    () => {
      if (!organizationId || !countryId) {
        return Promise.resolve([])
      }

      return fetchBanksList(organizationId, countryId)
    },
    {
      enabled: Boolean(organizationId && countryId),
      staleTime: Infinity,
      cacheTime: Infinity,
      onError: trackError,
    },
  )

  return {
    banks: data || [],
    isLoading: isLoading || isIdle,
  }
}
